module.exports = __webpack_public_path__ + "static/img/autumn_jianjiePic.0dc52477.png";